import { Routes, Route, Navigate } from 'react-router';
import { AppLayout } from '@/components/layout/AppLayout';
import { AuthGuard } from '@/lib/auth';
import Dashboard from '@/pages/Dashboard';
import TemplateList from '@/pages/TemplateList';
import QuestionBank from '@/pages/QuestionBank';
import TemplateEditor from '@/pages/TemplateEditor';
import TemplateReview from '@/pages/TemplateReview';
import ApprovalQueue from '@/pages/ApprovalQueue';
import Settings from '@/pages/Settings';
import Login from '@/pages/Login';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <AuthGuard>
            <AppLayout />
          </AuthGuard>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="templates" element={<TemplateList />} />
        <Route path="templates/new" element={<TemplateEditor mode="create" />} />
        <Route path="templates/:id" element={<TemplateEditor mode="edit" />} />
        <Route path="templates/:id/review" element={<TemplateReview />} />
        <Route path="approvals" element={<ApprovalQueue />} />
        <Route path="questions" element={<QuestionBank />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
